<template>
  <div v-if="canAccept">
    <BaseSectionHeader class="border-t border-strong-shadow-color pt-4 mb-4">
      {{ $t('Fill administrative details') }}
    </BaseSectionHeader>
    <BaseButton
      :to="`/opportunities/${$route.params.id}/accept`"
      :title="$t('I want to accept')"
      class="mb-6 md:mb-0"
      @click="trackAccept"
    />
  </div>
</template>

<script>
import BaseSectionHeader from '../../components/BaseSectionHeader.vue';
import BaseOrangeText from '../../components/BaseOrangeText.vue';
import BaseButton from '../../components/BaseButton.vue';
import { CLICKED_ACCEPT_BUTTON } from '../../analytics';

export default {
  name: 'AcceptButton',
  components: {
    BaseSectionHeader,
    BaseOrangeText,
    BaseButton,
  },
  props: {
    canAccept: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    trackAccept() {
      analytics.track(CLICKED_ACCEPT_BUTTON);
    },
  },
};
</script>
